export default __webpack_public_path__ + "check-marke55581.png";